import * as HTTP from './http';

export const GetSharedBoxes = async() => {
    let endpoint = `shippings/shared/box`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: shippings.GetSharedBoxes\n${e}`);
        return undefined;
    }

    return result;
}

export const GetDefaultBoxes = async() => {
    let endpoint = `shippings/defaults/boxes`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: shippings.GetDefaultBoxes\n${e}`);
        return undefined;
    }

    return result;
}


export const GetActiveShip = async(client) => {
    let endpoint = `shippings/active/${encodeURIComponent(client)}`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: shippings.GetActiveShip\n${e}`);
        return undefined;
    }

    return result;
}

export const GetSingleShip = async(order) => {
    let endpoint = `shippings/single/${order}`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: shippings.GetSingleShip\n${e}`);
        return undefined;
    }

    return result;
}

export const GetDefaultAddress = async(client) => {
    let endpoint = `shippings/address/${encodeURIComponent(client)}`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: shippings.GetDefaultAddress\n${e}`);
        return undefined;
    }

    return result;
}

export const CreateSingle = async(payload) => {
    let endpoint = `shippings/create/single`;

    try{
        var result = await HTTP.POST(endpoint,payload);
    }catch(e){
        console.log(`CONTROLLER ERROR: shippings.CreateSingle\n${e}`);
        return undefined;
    }

    return result;
}

export const PrintOrder = async(order, printer) => {
    let endpoint = `shippings/print/order/${encodeURIComponent(order)}/${encodeURIComponent(printer)}`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: shippings.PrintOrder\n${e}`);
        return undefined;
    }

    return result;
}

export const GetHoldOrder = async(order) => {
    let endpoint = `shippings/hold/order/${encodeURIComponent(order)}`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: shippings.GetHoldOrder\n${e}`);
        return undefined;
    }

    return result;
}

export const GetLabelHold = async(order) => {
    let endpoint = `shippings/label-hold/${encodeURIComponent(order)}`;
    try{
        return await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: shippings.GetLabelHold\n${e}`);
        return undefined;
    }
}

export const AddHoldOrder = async(payload) => {
    let endpoint = `shippings/hold/add`;

    try{
        var result = await HTTP.POST(endpoint,payload);
    }catch(e){
        console.log(`CONTROLLER ERROR: shippings.AddHoldOrder\n${e}`);
        return undefined;
    }

    return result;
}

export const GetHoldOrders = async() => {
    let endpoint = `shippings/hold/orders`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: shippings.GetHoldOrders\n${e}`);
        return undefined;
    }

    return result;
}

//#region CreatePlain
export const CreatePlain = async(payload) => {
    let endpoint = `shippings/create/plain`;

    try{
        var result = await HTTP.POST(endpoint,payload);
    }catch(e){
        console.log(`CONTROLLER ERROR: shippings.CreatePlain\n${e}`);
        return undefined;
    }

    return result;
}

//#region PrintBatch
export const PrintBatch = async(shipping, printer) => {
    let endpoint = `shippings/print/batch/${encodeURIComponent(shipping)}/${encodeURIComponent(printer)}`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: shippings.PrintBatch\n${e}`);
        return undefined;
    }

    return result;
}

//#region GetInfoByOrder
export const GetInfoByOrder = async(order) => {
    let endpoint = `shippings/info/order/${encodeURIComponent(order)}`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: shippings.GetInfoByOrder\n${e}`);
        return undefined;
    }

    return result;
}
